import modalIcon from "../assets/icons/warning-2@3x.png";
var modalData = {
  name: 'modal',
  data: [{
    showBgIcon: false,
    // 是否显示背景图
    wrapWidth: 250,
    wrapBgColor: '',
    iconWidth: 18,
    iconHeight: 18,
    fontFamily: 'PingFangSC-Semibold',
    fontSize: 12,
    titleColor: '#333333',
    descriptionColor: '#5a6677',
    iconImage: modalIcon,
    contentFont: 'PingFangSC-Regular',
    closeBtnTop: 17,
    closeBtnRight: 16,
    headerPadding: '16px 16px 12px',
    bodyPadding: 16,
    footerPadding: '12px 16px'
  }]
};
export default modalData;